import React, { PureComponent } from 'react';
import 'antd/dist/antd.css';
import { Form, Input, Button, message, Spin } from 'antd';
import { ReactComponent as ReactLogo } from "../../assets/motovolt_logo_for_splash_screen.svg"
import Cross from '../../assets/png/cross-vector.png'
import MotovoltLogo from '../../assets/motovolt_text.png'
import { signIn, initiateForgotPassword, forgotPasswordSubmit, getToken, signout, createPasswordSubmit } from "../../connectm-client/authentication"
import { withRouter, RouteComponentProps } from "react-router"
import { ReduxUserAction, ReduxUserState, mapDispatchToProps, mapStateToProps } from "../../connectm-client/actions/user"
import * as QueryString from "query-string"
import { connect } from 'react-redux'
import './index.scss'
import WebContent from "../webContentText.json"
import axios from 'axios';
import { Link } from 'react-router-dom';
import { setTimeout } from 'timers';
import { EyeInvisibleOutlined, EyeOutlined, LoadingOutlined } from '@ant-design/icons';
interface ForgotPasswordProps extends RouteComponentProps, ReduxUserAction, ReduxUserState { }
interface ForgotPasswordStates {
    formValid: string,
    valid: boolean,
    message: any,
    username:any,
    firstPassword: string,
    secondPassword: string,
    showLoader: boolean,
    showPasswordInitial:boolean,
    showPasswordFinal:boolean,
    emailId:string,
    orgId: string,
}
class CreatePassword extends PureComponent<ForgotPasswordProps, ForgotPasswordStates> {
    constructor(props: ForgotPasswordProps) {
        super(props)
        this.state = {
            formValid: '',
            valid: false,
            message: '',
            username:new URLSearchParams(this.props.location.search).get('emailId'),
            firstPassword: '',
            secondPassword: '',
            showLoader: false,
            showPasswordInitial:false,
            showPasswordFinal:false,
            emailId:"",
            orgId:""
        }
    }
    componentDidMount() {
        // Logout existing user when the component mounts
        const params = QueryString.parse(this.props.location.search);
        this.setState({emailId:String(params.emailId)})
        this.setState({orgId:String(params.org_id)})
        signout()
        .then(() => {
          this.props.usersAction({
            type: "UPDATE_USER",
            payload: {
              authenticated: false,
              user: null,
            },
          });
  
        //   this.props.history.push("/create-");
          localStorage.clear()
        })
    }

    validatePassword = (password: string) => {
        
        const regex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*&])[A-Za-z\d@$!%*&]{8,}$/;
        return regex.test(password);
   
    };
    onFinish = (values: any) => {
        const params = QueryString.parse(this.props.location.search);
        if (!this.validatePassword(this.state.secondPassword)  ) {
           
          
                // this.setState({
                //     formValid: 'error',
                //     valid: !this.state.valid,
                //     message: <span> <img src={Cross} height="20px" alt="cross" /> &nbsp;Invalid password format.</span>
                // });
                alert("Invalid password format. The password should be at least 8 characters, a mix of capital, lowercase letters, number, and a special symbol")

                setTimeout(() => {
                    // Clear the error message
                    this.setState({
                        formValid: "",
                        valid:false,
                        message:""
                    });
                }, 3000);
          
           
        } else if (this.state.secondPassword !== this.state.firstPassword) {

                this.setState({
                    formValid: 'error',
                    valid: !this.state.valid,
                    message: <span> <img src={Cross} height="20px" alt="cross" /> &nbsp;Passwords do not match.</span>
                });
        

            this.setState({
                // formValid: 'error',
                // valid: !this.state.valid,
                // message: <span> <img src={Cross} height="20px" alt="cross" /> &nbsp;Passwords do not match.</span>
            });
            setTimeout(() => {
                // Clear the error message
                this.setState({
                    formValid: "",
                    valid:false,
                    message:""
                });
            }, 3000);
        } else {
           
            this.setState({
                // showSuccessMessage: true, // Display success message
                showLoader: true, // Show the loader
            });
            createPasswordSubmit( this.state.emailId || '', this.state.orgId || '',this.state.secondPassword)
                .then(async (forgotPasswordObj) => {
                    const forgotPasswordObj1 = forgotPasswordObj?.data;
                    if (forgotPasswordObj1?.message === "Success") {
                        this.props.usersAction({
                            type: "UPDATE_USER",
                            payload: {
                                authenticated: false,
                                user: null
                            }
                        })
                        message.success("User has been verified successfully. You will be redirected to login page..")
                       setTimeout(() => {
                            this.setState({
                                showLoader: false,
                            });
                            this.props.history.push("/login");
                        },1000);
                       
                        
                    }
                    else if(forgotPasswordObj1?.code === 400){
                   alert("password reset failed");
                   setTimeout(() => {
                    this.setState({
                        showLoader: false,
                    });
                   // this.props.history.push("/login");
                },1000);
                    }
                    else {
                        setTimeout(() => {
                            this.setState({
                                showLoader: false, // Set the state variable to false to hide the loader
                            });

                            // Redirect to the login page
                            // this.props.history.push("/login");
                        }, 1000);
                       
                        if (forgotPasswordObj1?.code === 400){

                            setTimeout(()=>{
                                this.setState({
                                    formValid: 'error',
                                    valid: !this.state.valid,
                                    message: <span> <img src={Cross} height="20px" alt="cross" /> &nbsp;User already exists.</span>
                                })
                            }, 1000)
                           
                        }
                        else{
                            setTimeout(() => {
                                this.setState({
                                    showLoader: false, // Set the state variable to false to hide the loader
                                });
    
                                // Redirect to the login page
                                // this.props.history.push("/login");
                            },1000);

                            setTimeout(()=>{
                                this.setState({
                                    formValid: 'error',
                                    valid: !this.state.valid,
                                    message: <span> <img src={Cross} height="20px" alt="cross" /> &nbsp;Could not Reset Password.</span>
                                })
                            },1000)

                      
                    }
                    }
                })

                setTimeout(() => {
                    // Clear the error message
                    this.setState({
                        formValid: "",
                        valid:false,
                        message:""
                    });
                }, 3000);
        }
    };

    // updateUsername = (event: any) => {
    //     this.setState({
    //         username : "AA"
    //     })
    // }

    updateFirstPassword = (event: any) => { 
        this.setState({
            firstPassword: event.target.value
        })
    }

    updateSecondPassword = (event: any) => {
        this.setState({
            secondPassword: event.target.value
        })
    }

    render() {
        return (
            <div className="connectm-forgot">
                <div className="forgot-password-container">
                    <div className="login-image">
                        <div className="logo-title">
                            <div className="command-center"><span style={{ fontSize: "40px" }}>Create Password</span></div>
                            <div className="command-center"><span>Command Center</span></div>
                        </div>
                    </div>
                    <div className="login-form">
                        <div className={`notification-toast ${this.state.formValid}`}>
                            {this.state.message}
                        </div>
                        <div className={"form-body"}>
                            <div className="logo">
                            </div>
                            { this.state.showLoader === false  ? <div className="forgot-password-label" style={{marginBottom:"10px", fontSize:"10px"}}>Enter a new password. The password should be at least 8 characters, a mix of capital, lowercase letters, number, and a special symbol. </div> : <div className="forgot-password-label" />}
                            {this.state.showLoader ? (
                                <div
                                    style={{
                                        height: "40vh",
                                        display: "flex",
                                        justifyContent: "center",
                                        alignItems: "center",
                                        flexDirection: "column",
       
                                        
                                        
                                    }}
                                >
                                    <Spin
                                        indicator={
                                            <LoadingOutlined
                                                className="loading"
                                                style={{ fontSize: 24 }}
                                                spin
                                            />
                                        }
                                    />

                                    <h1 className="loading-text" style={{ margin: "10px" }}>Loading.....</h1>
                                </div>
                            ) : (
                                <Form
                                    name="normal_login"
                                    className="ant-login-form"
                                    initialValues={{
                                        remember: true,
                                    }}
                                    onFinish={this.onFinish}>
                                     <p style={{marginLeft : "50px"}}>{this.state.username}</p>
                                    <Form.Item
                                        name="password"
                                        rules={[
                                            {
                                                required: true,
                                                message: '',
                                            },
                                        ]}>
                                        <Input
                                            type={this.state.showPasswordInitial ? "text" : "password"}
                                            addonAfter={
                                                <Button
                                                  type="link"
                                                  onClick={() => this.setState({ showPasswordInitial: !this.state.showPasswordInitial })}
                                                >
                                                  {this.state.showPasswordInitial ?  <EyeOutlined /> : <EyeInvisibleOutlined /> }
                                                </Button>
                                              }
                                            placeholder="New Password"
                                            value={this.state.firstPassword}
                                            onChange={this.updateFirstPassword} />
                                    </Form.Item>
                                    <Form.Item
                                        name="confirmPassword"
                                        rules={[
                                            {
                                                required: true,
                                                message: '',
                                            },
                                        ]}>
                                        <Input
                                             type={this.state.showPasswordFinal ? "text" : "password"}
                                             addonAfter={
                                                 <Button
                                                   type="link"
                                                   onClick={() => this.setState({ showPasswordFinal: !this.state.showPasswordFinal })}
                                                 >
                                                   {this.state.showPasswordFinal ?  <EyeOutlined /> : <EyeInvisibleOutlined /> }
                                                 </Button>
                                               }
                                            placeholder="Confirm Password"
                                            value={this.state.secondPassword}
                                            onChange={this.updateSecondPassword}
                                        />
                                    </Form.Item>

                                    <Form.Item>
                                        <Button type="primary" htmlType="submit" className="login-form-button" style={{ color: "white" }} >
                                            Continue
                                        </Button>
                                    </Form.Item>
                                </Form>
                            )}
                        </div>
                    </div>
                </div>

                <div className="forgot-footer">
                    <div>
                        Copyright © {new Date().getFullYear()}. All rights reserved.
                    </div>
                    <div>
                        {WebContent.version}
                    </div>
                </div>
            </div>
        )
    }

}

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(CreatePassword));